export default __webpack_public_path__ + "static/media/health_green.b5a4ca06.svg";